var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.625918L0 1.81015C0 1.89068 0.0292969 1.96647 0.0773438 2.01384L4.66641 6.4997L0.0773438 10.9856C0.0292969 11.0329 0 11.1087 0 11.1893L0 12.3735C0 12.4761 0.0867189 12.5361 0.148828 12.4761L5.84531 6.90865C6.05156 6.70655 6.05156 6.29286 5.84531 6.09233L0.148828 0.524864C0.0867189 0.463284 0 0.523285 0 0.625918Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.271d4e3ead75ca0142b75b7dce5c6868.svg";
export { ForwardRef as ReactComponent };